import { connect } from 'react-redux'
import requestAddNewLabel from '../../../sagas/requestAddNewLabel'
import CreateLabel from './CreateLabel'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  null,
  {
    requestAddNewLabel
  }
)(CreateLabel))
